import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgCheck = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.2314 3.97527C12.5395 4.17677 12.626 4.58993 12.4245 4.89809L7.8912 11.8314C7.78436 11.9949 7.61128 12.1031 7.41763 12.1279C7.22398 12.1526 7.02923 12.0912 6.88477 11.9599L3.95144 9.29321C3.679 9.04554 3.65892 8.62391 3.90659 8.35148C4.15426 8.07904 4.57589 8.05895 4.84833 8.30663L7.20313 10.4473L11.3086 4.16842C11.5101 3.86026 11.9232 3.77379 12.2314 3.97527Z"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgCheck)
const IconSvgCheck = createIcon(ForwardRef, 'SvgCheck')
export default IconSvgCheck
